import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Optional, SkipSelf } from '@angular/core';
import { InternalNodeMappingService } from 'app/nodes/node-attributes/internal-node-mapping-service';
import { MomentLocaleInitService } from 'app/shared/locale/moment-locale-init.service';
import { MessageService } from 'primeng/api';
import { NotificationService } from '../notifications/notification.service';
import { AuditEntityService } from './audit-entity.service';
import { AuthModule } from './auth/auth.module';
import { AuthorizationGuardService } from './authorization-guard.service';
import { BackendService } from './backend.service';
import { BlobBackendService } from './blob-backend.service';
import { BootstrapImportsModule } from './bootstrap-imports.module';
import { CommonValidationService } from './common-validation.service';
import { ConfigService } from './config.service';
import { DomainTerminologyTranslationService } from './domain-terminology/domain-terminology-translation.service';
import { InspectorsService } from './inspectors.service';
import { ClientTranslationService } from './internationalization/client-translation-service';
import { LicensingService } from './licensing/licensing.service';
import { throwIfModuleAlreadyLoaded } from './module-load-guard';
import { SpinnerModule } from './spinner/spinner.module';
import { StaticLookupService } from './static-lookups/static-lookup.service';
import { DomainConfigurationService } from './system-configuration/domain-configuration.service';
import { SystemConfigurationService } from './system-configuration/system-configuration.service';
import { SystemSettings } from './system-configuration/system-settings';

// imports: imports the module's exports. which is usually declarables and providers
// in our case the spinner has no providers.
//
// exports: exports modules AND components/directives/pipes that other modules may want to use
@NgModule({
  imports: [BootstrapImportsModule, CommonModule, HttpClientModule, SpinnerModule, AuthModule],
  exports: [BootstrapImportsModule, CommonModule, SpinnerModule, AuthModule],
  declarations: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    AuditEntityService,
    AuthorizationGuardService,
    BackendService,
    BlobBackendService,
    ConfigService,
    StaticLookupService,
    InternalNodeMappingService,
    LicensingService,
    MessageService,
    MomentLocaleInitService,
    CommonValidationService,
    InspectorsService,
    NotificationService,
    SystemConfigurationService,
    SystemSettings,
    DomainConfigurationService,
    DomainTerminologyTranslationService,
    ClientTranslationService,
    HttpClient,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfModuleAlreadyLoaded(parentModule, 'CoreModule');
  }
}
